import type { Module } from '@/types/modules';
import '../_infrastructure/ModuleStyles.css';

interface MapModuleProps {
  module: Module;
  conversationId?: string;
  [legacyProp: string]: unknown;
}

export default function MapModule({ module }: MapModuleProps) {
  return (
    <div className="module">
      <div className="module-accent-rail" style={{ background: 'var(--color-border)' }} />
      <div className="module-content">
        <p className="empty-state-text">Map module coming soon</p>
      </div>
    </div>
  );
}
